module.exports = __webpack_public_path__ + "img/木鳖子.2dd0dfd7.jpg";